__turbopack_context__.v({
  "accent": "segmented-progress-module__tc539W__accent",
  "filled": "segmented-progress-module__tc539W__filled",
  "lg": "segmented-progress-module__tc539W__lg",
  "md": "segmented-progress-module__tc539W__md",
  "segment": "segmented-progress-module__tc539W__segment",
  "sm": "segmented-progress-module__tc539W__sm",
  "success": "segmented-progress-module__tc539W__success",
  "track": "segmented-progress-module__tc539W__track",
  "warning": "segmented-progress-module__tc539W__warning",
  "xl": "segmented-progress-module__tc539W__xl",
});
